import type { UserListItem } from './api';

/** Roles whose work is tied to a point: an unassigned user of these sees every point (R2). */
const OPERATIONAL_ROLE_CODES = ['KITCHEN', 'DELIVERY', 'BILLING'];

/**
 * `internal-users/spec.md` → "Advertencia de alcance total en roles
 * operativos": no assignment on an operational role, with more than one
 * active point to see.
 */
export function seesAllOperatingUnits(
  user: Pick<UserListItem, 'roleCodes' | 'operatingUnits'>,
  activeUnitCount: number,
): boolean {
  return (
    activeUnitCount > 1 &&
    user.operatingUnits.length === 0 &&
    user.roleCodes.some((code) => OPERATIONAL_ROLE_CODES.includes(code))
  );
}
